import { render, staticRenderFns } from "./sport_event_review_created.vue?vue&type=template&id=e0acdbe8&scoped=true&"
import script from "./sport_event_review_created.vue?vue&type=script&lang=js&"
export * from "./sport_event_review_created.vue?vue&type=script&lang=js&"
import style0 from "./sport_event_review_created.vue?vue&type=style&index=0&id=e0acdbe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0acdbe8",
  null
  
)

export default component.exports